import React, { Component } from 'react';
import 'antd/dist/antd.css';
import { Form, Select, Button, message } from 'antd';
import { Spinner } from 'reactstrap';
import axios from '../../utils/request';

const { Option } = Select;
let tenantId = "";

const formLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
};

export class ChangJiangCunChuInitiateEvaluation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReady: false,
            isLoading: true,
            errorMessage: "",
            evaluationDirections: [],
            tenantId: "",
            evaluationDirection: "",
            commonParamater: "",
            messageCode: ""
        }
    };

    formRef = React.createRef();

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        let commonParamater = urlParams.get("commonParamater");
        tenantId = urlParams.get("tenantId");
        this.state.messageCode = urlParams.get("messageCode");

        //参数校验
        if (!commonParamater) {
            this.setState({ errorMessage: "commonParamater不存在！", isLoading: false, isReady: true });
            return;
        }

        this.state.commonParamater = commonParamater;
        this.state.tenantId = tenantId;
        this.loadPage(tenantId, commonParamater);
    };

    loadPage = (tenantId, commonParamater) => {
        const params = {
            tenantId,
            commonParamater
        }

        //获取长江存储测评方向数据源
        axios
            .get("/api/ChangJiangCunChu/GetEvaluationDirections", { params: params })
            .then(res => {
                let errorMessage = "";

                if (res.status == 200 && res.data.code == "200") {
                    this.setState({
                        evaluationDirections: res.data.data.dataSource
                    });

                    if (res.data.data.hasInitiatedApply == true)
                        message.warn(res.data.data.repeatInitiatedMessage);
                }
                else {
                    errorMessage = "获取测评方向失败";
                    this.setState({ isLoading: false, isReady: true, errorMessage });
                }

                this.setState({ isLoading: false, isReady: true, errorMessage });
            })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" });
            })
            .finally(
            );
    };

    onFinish = async (values) => {
        const fieldsValue = await this.formRef.current.validateFields();
        console.log(fieldsValue);
        const params = {
            tenantId: this.state.tenantId,
            commonParamater: this.state.commonParamater,
            evaluationDirection: fieldsValue.EvaluationDirection,
        };

        const bodyString = JSON.stringify(params);
        axios
            .post("/api/ChangJiangCunChu/SaveEvaluationDirection", bodyString,
                {
                    headers: { "Content-Type": "application/json" }
                })
            .then(res => {
                let errorMessage = "";
                if (res.status == 200 && res.data.code == "200") {
                    errorMessage = "保存测评方向成功";
                    this.setState({ isLoading: false, isReady: true, errorMessage });
                    //操作完成后 关闭弹窗
                    window.parent.postMessage(
                        {
                            msgCode: this.state.messageCode,
                            Code: 200,
                            Message: '保存成功',
                            isClose: true,
                        },
                        '*'
                    );
                }
                else {
                    errorMessage = "保存测评方向失败";
                    this.setState({ isLoading: false, isReady: true, errorMessage });
                }
            })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" });
            })
            .finally(
            );
    };

    render() {
        if (this.state.isReady) {
            if (this.state.errorMessage !== "") {
                return (<div style={{ textAlign: "center", padding: "32px" }}><span style={{ color: "red" }}>{this.state.errorMessage}</span></div>)
            }
            else {
                return (
                    <>
                        <div style={{ paddingTop: '60px', paddingBottom: '14px', textAlign: "center" }}>
                            <p style={{ width: '170px', fontSize: '20px', margin: "auto" }}>邀请翰威特测评</p>
                        </div>
                        <Form onFinish={this.onFinish} ref={this.formRef} {...formLayout} style={{ paddingTop: '20px' }}>
                            <Form.Item name="EvaluationDirection" label="测评方向" required
                                rules={[
                                    {
                                        required: true,
                                        message: '请选择测评方向',
                                    },
                                ]}
                            >
                                <Select showSearch placeholder="---请选择测评方向---">
                                    {
                                        //数据绑定
                                        this.state.evaluationDirections.map((item) => (
                                            <Option key={item.value}>{item.text}</Option>
                                        ))
                                    }
                                </Select>
                            </Form.Item>
                            <Form.Item wrapperCol={{ offset: "4", span: "16" }}>
                                <div style={{ paddingTop: "18px", textAlign: "center" }}>
                                    <Button type="prmary" htmlType="submit" margin="auto">提交</Button>
                                </div>
                            </Form.Item>
                        </Form>
                    </>
                )
            }
        }
        else {
            return (
                <div style={{ textAlign: "center", lineHeight: "100vh" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }
    }
}